import { useEffect, useState } from 'react';
import { useSnapshot } from 'valtio';

import Panel from '@cartwhl/ui/layout/Panel';

import { projectStore, uiStore } from 'stores';

import GenerationHistoryNew from './GenerationHistoryNew';
import PanelSearch from './PanelSearch';

export default function MotionProjectHistoryPanel({
  close,
  isOpen,
  enterTransitionDuration = 0,
  exitTransitionDuration = 0,
}: {
  close: () => void;
  isOpen?: boolean;
  enterTransitionDuration?: number;
  exitTransitionDuration?: number;
}) {
  const { currentProject } = useSnapshot(projectStore.state);
  const { subPanelKey } = useSnapshot(uiStore.state);
  const [isSearchBarActive, setSearchBarActive] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    // TODO: Use a ref instead. Couln't get it to work with the complicated Input component...
    const input = document.getElementById('panel-search-input');
    if (!input) return;
    if (isSearchBarActive) {
      input.focus();
    } else {
      input.blur();
    }
  }, [isSearchBarActive]);

  return (
    <Panel
      title="History"
      closePanel={close}
      subPanelKey={subPanelKey}
      isOpen={isOpen}
      enterTransitionDuration={enterTransitionDuration}
      exitTransitionDuration={exitTransitionDuration}
      additionalButtons={
        <PanelSearch
          isSearchBarActive={isSearchBarActive}
          setSearchBarActive={setSearchBarActive}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />
      }
    >
      <GenerationHistoryNew searchTerm={searchTerm} />
    </Panel>
  );
}
